/**
 * Customers and customer contacts API calls.
 */

import client from './client';

// --- Customers ---

export async function fetchCustomers(params = {}) {
  const { data } = await client.get('/customers/', { params });
  return data;
}

export async function fetchCustomer(id) {
  const { data } = await client.get(`/customers/${id}/`);
  return data.data || data;
}

export async function createCustomer(payload) {
  const { data } = await client.post('/customers/', payload);
  return data.data || data;
}

export async function updateCustomer(id, payload) {
  const { data } = await client.patch(`/customers/${id}/`, payload);
  return data.data || data;
}

export async function deleteCustomer(id) {
  await client.delete(`/customers/${id}/`);
}

export async function restoreCustomer(id) {
  const { data } = await client.post(`/customers/${id}/restore/`);
  return data.data || data;
}

// --- Customer Contacts ---

export async function fetchContacts(params = {}) {
  const { data } = await client.get('/customers/contacts/', { params });
  return data;
}

export async function fetchContact(id) {
  const { data } = await client.get(`/customers/contacts/${id}/`);
  return data.data || data;
}

export async function createContact(payload) {
  const { data } = await client.post('/customers/contacts/', payload);
  return data.data || data;
}

export async function updateContact(id, payload) {
  const { data } = await client.patch(`/customers/contacts/${id}/`, payload);
  return data.data || data;
}

export async function deleteContact(id) {
  await client.delete(`/customers/contacts/${id}/`);
}
